export default "__VITE_ASSET__BcT$rD9Z__"